import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, MapPin } from 'lucide-react';
import { useLanguage } from '../../i18n';

const Footer = () => {
  const currentYear = new Date().getFullYear();
  const { t, getContact } = useLanguage();
  const contact = getContact();

  const navItems = [
    { label: t('nav.home'), href: '/' },
    { label: t('nav.skills'), href: '/skills' },
    { label: t('nav.missions'), href: '/missions' },
    { label: t('nav.employers'), href: '/employers' },
    { label: t('nav.certifications'), href: '/certifications' },
    { label: t('nav.contact'), href: '/contact' },
  ];

  return (
    <footer className="bg-slate-900 text-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-12 py-12 lg:py-16">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 lg:gap-12">
          <div>
            <h3 className="font-mono text-sm uppercase tracking-wider mb-4 text-slate-400">
              Joel.Dossa
            </h3>
            <p className="font-body text-sm text-slate-300 leading-relaxed">
              {t('footer.consultant')}
            </p>
          </div>

          <div>
            <h3 className="font-mono text-sm uppercase tracking-wider mb-4 text-slate-400">
              {t('footer.navigation')}
            </h3>
            <nav className="flex flex-col gap-2">
              {navItems.map((item) => (
                <Link
                  key={item.href}
                  to={item.href}
                  className="font-body text-sm text-slate-300 hover:text-white"
                >
                  {item.label}
                </Link>
              ))}
            </nav>
          </div>

          <div>
            <h3 className="font-mono text-sm uppercase tracking-wider mb-4 text-slate-400">
              {t('footer.contact')}
            </h3>
            <div className="flex flex-col gap-3">
              <a 
                href={`mailto:${contact.email}`}
                className="flex items-center gap-3 text-sm text-slate-300 hover:text-white"
              >
                <Mail className="w-4 h-4" />
                {contact.email}
              </a>
              <div className="flex items-center gap-3 text-sm text-slate-300">
                <MapPin className="w-4 h-4" />
                {contact.mobility}
              </div>
            </div>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-slate-800 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="font-mono text-xs text-slate-500 uppercase tracking-wider">
            © {currentYear} Joel Dossa. {t('footer.rights')}.
          </p>
          <p className="font-mono text-xs text-slate-500 uppercase tracking-wider">
            {t('footer.consultant')}
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
